import { defineNuxtPlugin } from '#app/nuxt'
import { LazyMopCmsContentElementsSlot, LazyMopCmsCompanyAudio, LazyMopCmsCompanyBlogNewsTripleCard, LazyMopCmsCompanySocialFeed, LazyMopCmsCompanyTopJobs, LazyMopCmsCompanyVacancies, LazyJobFiltersOverlay, LazyUiCmsAnchor, LazyUiCmsBadge, LazyUiCmsBenefit, LazyUiCmsCardCarousel, LazyUiCmsCardItem, LazyUiCmsCountdown, LazyUiCmsCta, LazyUiCmsDoubleCard, LazyUiCmsElementNotFound, LazyUiCmsFullWidthBanner, LazyUiCmsGenderSwitch, LazyUiCmsGenderSwitchItem, LazyUiCmsHeadline, LazyUiCmsHtml, LazyUiCmsImageText, LazyUiCmsMedia, LazyUiCmsRichText, LazyUiCmsRow, LazyUiCmsSeoTeaser, LazyUiCmsSeparator, LazyUiCmsSlider, LazyUiCmsSliderSlide, LazyUiCmsStaticNavigation, LazyUiCmsTable, LazyUiCmsTextCarousel, LazyUiCmsTimeline, LazyUiCmsTimelineItem, LazyUiCmsTripleCard, LazyUiCmsTripleTeaser, LazyUiCmsTripleTeaserItemBig, LazyUiCmsTripleTeaserItemSmall, LazyUiCmsVideoVimeo, LazyUiCarousel, LazyUiForm, LazyUiFormCheckbox, LazyUiFormGroup, LazyUiFormInput, LazyUiFormSelect, LazyUiFormTextArea, LazyUiGoogleMap, LazyUiHeading, LazyUiImage, LazyUiImageCarousel, LazyUiNotification, LazyUiNuxtLink, LazyUiPagination, LazyUiSlot, LazyUiTooltip, LazyUiVideoVimeo, LazyMopBlogNewsItem, LazyMopBreadcrumb, LazyMopCookiesOverlay, LazyMopNavigationTree, LazyMopNotFound, LazyMopPageLoad, LazyMopSearchForm, LazyMopFooter, LazyMopFooterJobsStickyButton, LazyMopHeader, LazyMopHeaderMenuOverlay, LazyMopHeaderMobileMenuOverlay, LazyMopHeaderMobileMenuSlider, LazyMopHeaderSearchSuggestionsOverlay, LazyMopJobFilter, LazyMopJobFilters, LazyMopOverlayManager, LazyMopOverlay, LazyUi2Badge, LazyUi2Button, LazyUi2Carousel, LazyUi2CarouselArrow, LazyUi2CarouselScrollBar, LazyUi2CarouselSlide, LazyUi2CompanyAudio, LazyUi2DropdownMenu, LazyUi2DropdownSelect, LazyUi2DropdownSelectItem, LazyUi2FileUpload, LazyUi2Form, LazyUi2Heading, LazyUi2Icon, LazyUi2Loader, LazyUi2Notification, LazyUi2NuxtLink, LazyUi2PaginationDots, LazyUi2Radio, LazyUi2TextFieldInput } from '#components'
const lazyGlobalComponents = [
  ["MopCmsContentElementsSlot", LazyMopCmsContentElementsSlot],
["MopCmsCompanyAudio", LazyMopCmsCompanyAudio],
["MopCmsCompanyBlogNewsTripleCard", LazyMopCmsCompanyBlogNewsTripleCard],
["MopCmsCompanySocialFeed", LazyMopCmsCompanySocialFeed],
["MopCmsCompanyTopJobs", LazyMopCmsCompanyTopJobs],
["MopCmsCompanyVacancies", LazyMopCmsCompanyVacancies],
["JobFiltersOverlay", LazyJobFiltersOverlay],
["UiCmsAnchor", LazyUiCmsAnchor],
["UiCmsBadge", LazyUiCmsBadge],
["UiCmsBenefit", LazyUiCmsBenefit],
["UiCmsCardCarousel", LazyUiCmsCardCarousel],
["UiCmsCardItem", LazyUiCmsCardItem],
["UiCmsCountdown", LazyUiCmsCountdown],
["UiCmsCta", LazyUiCmsCta],
["UiCmsDoubleCard", LazyUiCmsDoubleCard],
["UiCmsElementNotFound", LazyUiCmsElementNotFound],
["UiCmsFullWidthBanner", LazyUiCmsFullWidthBanner],
["UiCmsGenderSwitch", LazyUiCmsGenderSwitch],
["UiCmsGenderSwitchItem", LazyUiCmsGenderSwitchItem],
["UiCmsHeadline", LazyUiCmsHeadline],
["UiCmsHtml", LazyUiCmsHtml],
["UiCmsImageText", LazyUiCmsImageText],
["UiCmsMedia", LazyUiCmsMedia],
["UiCmsRichText", LazyUiCmsRichText],
["UiCmsRow", LazyUiCmsRow],
["UiCmsSeoTeaser", LazyUiCmsSeoTeaser],
["UiCmsSeparator", LazyUiCmsSeparator],
["UiCmsSlider", LazyUiCmsSlider],
["UiCmsSliderSlide", LazyUiCmsSliderSlide],
["UiCmsStaticNavigation", LazyUiCmsStaticNavigation],
["UiCmsTable", LazyUiCmsTable],
["UiCmsTextCarousel", LazyUiCmsTextCarousel],
["UiCmsTimeline", LazyUiCmsTimeline],
["UiCmsTimelineItem", LazyUiCmsTimelineItem],
["UiCmsTripleCard", LazyUiCmsTripleCard],
["UiCmsTripleTeaser", LazyUiCmsTripleTeaser],
["UiCmsTripleTeaserItemBig", LazyUiCmsTripleTeaserItemBig],
["UiCmsTripleTeaserItemSmall", LazyUiCmsTripleTeaserItemSmall],
["UiCmsVideoVimeo", LazyUiCmsVideoVimeo],
["UiCarousel", LazyUiCarousel],
["UiForm", LazyUiForm],
["UiFormCheckbox", LazyUiFormCheckbox],
["UiFormGroup", LazyUiFormGroup],
["UiFormInput", LazyUiFormInput],
["UiFormSelect", LazyUiFormSelect],
["UiFormTextArea", LazyUiFormTextArea],
["UiGoogleMap", LazyUiGoogleMap],
["UiHeading", LazyUiHeading],
["UiImage", LazyUiImage],
["UiImageCarousel", LazyUiImageCarousel],
["UiNotification", LazyUiNotification],
["UiNuxtLink", LazyUiNuxtLink],
["UiPagination", LazyUiPagination],
["UiSlot", LazyUiSlot],
["UiTooltip", LazyUiTooltip],
["UiVideoVimeo", LazyUiVideoVimeo],
["MopBlogNewsItem", LazyMopBlogNewsItem],
["MopBreadcrumb", LazyMopBreadcrumb],
["MopCookiesOverlay", LazyMopCookiesOverlay],
["MopNavigationTree", LazyMopNavigationTree],
["MopNotFound", LazyMopNotFound],
["MopPageLoad", LazyMopPageLoad],
["MopSearchForm", LazyMopSearchForm],
["MopFooter", LazyMopFooter],
["MopFooterJobsStickyButton", LazyMopFooterJobsStickyButton],
["MopHeader", LazyMopHeader],
["MopHeaderMenuOverlay", LazyMopHeaderMenuOverlay],
["MopHeaderMobileMenuOverlay", LazyMopHeaderMobileMenuOverlay],
["MopHeaderMobileMenuSlider", LazyMopHeaderMobileMenuSlider],
["MopHeaderSearchSuggestionsOverlay", LazyMopHeaderSearchSuggestionsOverlay],
["MopJobFilter", LazyMopJobFilter],
["MopJobFilters", LazyMopJobFilters],
["MopOverlayManager", LazyMopOverlayManager],
["MopOverlay", LazyMopOverlay],
["Ui2Badge", LazyUi2Badge],
["Ui2Button", LazyUi2Button],
["Ui2Carousel", LazyUi2Carousel],
["Ui2CarouselArrow", LazyUi2CarouselArrow],
["Ui2CarouselScrollBar", LazyUi2CarouselScrollBar],
["Ui2CarouselSlide", LazyUi2CarouselSlide],
["Ui2CompanyAudio", LazyUi2CompanyAudio],
["Ui2DropdownMenu", LazyUi2DropdownMenu],
["Ui2DropdownSelect", LazyUi2DropdownSelect],
["Ui2DropdownSelectItem", LazyUi2DropdownSelectItem],
["Ui2FileUpload", LazyUi2FileUpload],
["Ui2Form", LazyUi2Form],
["Ui2Heading", LazyUi2Heading],
["Ui2Icon", LazyUi2Icon],
["Ui2Loader", LazyUi2Loader],
["Ui2Notification", LazyUi2Notification],
["Ui2NuxtLink", LazyUi2NuxtLink],
["Ui2PaginationDots", LazyUi2PaginationDots],
["Ui2Radio", LazyUi2Radio],
["Ui2TextFieldInput", LazyUi2TextFieldInput],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
